import React, { Component } from "react";
import { useEffect, useState } from 'react';
import axios from 'axios'; // Asegúrate de importar axios
// Import from bootstrap
import { Container, Row, Col, transform } from "react-bootstrap";

// Import constant url
import { AGENT_ART_URL, AGENT_VIDEO_URL } from "../utils/Const";


// Import Components
import SelectArmasComp from "./SelectArmasComp";
import AgentsDesc from "./AgentsDesc";
import AgentSkill from "./AgentSkill";
import { armasData } from "../ArmasData";
let currentURL = window.location.href.split("/");
let idMapa = currentURL[4];



const SkinsComp = () => {
  
  const [armasDataAPI, setarmasDataAPI] = useState([]); // Cambia aquí el nombre de la variable
  const [combinedarmasData, setCombinedarmasData] = useState([]);
 
  
  // console.log("uuid por url:  " + idMapa);
  useEffect(() => {
    axios.get('https://valorant-api.com/v1/weapons?language=es-MX')
      .then(response => {
        const apiarmasData = response.data.data;
        setarmasDataAPI(apiarmasData);
  
        const combinedData = apiarmasData.map((apiAgent) => {
          const localAgent = armasData.find((agent) => agent.uuid === apiAgent.uuid);

          return {
            ...apiAgent,
            ...localAgent,
          };
        });
  
        setCombinedarmasData(combinedData);
      })
      .catch(error => {
        console.error('Error al obtener los datos de la API:', error);
      });
  }, []);
  // console.log(combinedarmasData);
  const filteredAgents = combinedarmasData.filter(agent => agent.uuid === idMapa);
  console.log("SkinsComp: ");
  console.log(filteredAgents);
  
    return (
        <>
      <section className="mapas-container">   
      <Container>         
            <div className="habilidades-container" >
            <Row>
            {filteredAgents.map(agent => (
              <Col xs={12} sm={6} className="p-5 order-1 order-sm-0">
                <div className="skill-description">
                  <h3 className="d-flex align-items-center">
                    <strong>{agent.displayName}</strong>
                  </h3>
                  <img src={agent.displayIcon} alt={agent.displayName} className="responsive-image"/>
                </div>
              </Col>
              ))}  
              <Col xs={12} sm={6} className="p-5 order-1 order-sm-0">
              {filteredAgents.map(agent => (
                  <div>
                    <div>
                      <br></br>
                      <p>{agent.bio}</p>
                    </div>
                    <img src={agent.killStreamIcon} alt={agent.displayName} className="responsive-image"/>
                  </div>
                ))}  
              </Col>
            </Row>
          </div>
          <p>skins del arma</p>
        </Container>     
      </section>
      <h1><strong>Muy pronto</strong></h1>
      <SelectArmasComp />  
      </>
    );

}
export default SkinsComp
